export default "__VITE_ASSET__CiLpMc6q__"